module.exports = __webpack_public_path__ + "static/media/phone-call.e4f43b95.svg";